module.exports = __webpack_public_path__ + "static/ch-him2-lp-quiz-1-87c828947cb9283d461b09870e87964c.jpg";